import gql from 'graphql-tag'

export const CONSULTANT_NOTIFICATION_EMAIL_ADDRESS_CREATE_MUTATION = gql`
    mutation consultantNotificationEmailAddressCreate(
        $consultantId: ID!
        $consultantNotificationEmailAddress: ConsultantNotificationEmailAddressInput!
    ) {
        consultantNotificationEmailAddressCreate(
            consultant_id: $consultantId
            consultantNotificationEmailAddress: $consultantNotificationEmailAddress
        ) {
            id
            email
            notificationEmitters
            created_at
            updated_at
        }
    }
`
